import { AllowedDeliveryChannel } from "clearline-api";
import { WidgetType } from "clearline-common";

export class FeatureModel {
  get code() {
    return this.id.toString();
  }
  public deliveryMethod?: AllowedDeliveryChannel;
  constructor(public id: WidgetType, public icon: string, public name: string = "") {}
}

export class WidgetModel {
  get code() {
    return this.id.toString();
  }

  constructor(public id: WidgetType, public name: string, public icon: string, public disabled = false) {}
}
